"use strict";

/**
 * Desktop banner inside video when it's paused
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);

  // to prevent double loading/execution in SPA mode
  var loaded = false;

  /**
   * Do stuff on the page load
   */
  function onPageLoad() {
    if (loaded) {
      // to prevent double loading/execution in SPA mode
      return;
    }
    loaded = true;

    // Hide Ads on close overlay and continue video playing
    document.addEventListener('click', function (e) {
      if (e.target.closest('.pause-overlay')) {
        FlixVideo.playVideo();
      }
    });
    document.addEventListener('flix:video:ready', function (e) {
      return onPlayerReady(e.detail.player);
    });
  }

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled
    /** Desktop only */ && FlixUtils.isDesktop()
    /** Only on video page */ && document.querySelector('#in_video_ad');
  }
  ;

  /**
   * Main logic
   * @param {Object} player Plyr instance
   */
  function onPlayerReady(player) {
    if (!isEnabled()) {
      return;
    }
    player.on('pause', function () {
      document.querySelector('.pause-overlay').classList.remove('d-none');
    });
    player.on('play seeking', function () {
      document.querySelector('.pause-overlay').classList.add('d-none');
    });
    FlixUtils.renderBannerAd(getZoneId(), document.querySelector('#in_video_ad'), 'eas6a97888e38', 'ad_error_invideo');
  }
  ;
  function getZoneId() {
    if (Flix.isTna()) {
      return '4505232';
    } else {
      return '4505288';
    }
  }
})();